import React from "react";
import { useBreakpoint } from "helpers/hooks";
import styles from "./Default.module.scss";

const DefaultLayout: Components.Layout = ({
  header,
  footer,
  content,
  navBar,
}: Components.Layout.Props) => {
  const breakpoint = useBreakpoint(true);
  const isMobile = breakpoint === "mobile";
  const isTablet = breakpoint === "tablet";

  return (
    <div className={styles.layout}>
      {header}
      <div className={styles.layoutContent} role="main">
        {content}
      </div>
      {footer}
      {(isMobile || isTablet) && navBar}
    </div>
  );
};

export default DefaultLayout;
